
import { Options, Vue } from 'vue-class-component'

@Options({
    props: {
        modalText: {
            type: String,
            default: '',
        }, 
        btnText: {
            type: String,
            default: '',
        },
        showCancel: {
            type: Boolean,
            default: false,
        },
        cancelText: {
            type: String,
            default: '',
        },
        submitText: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
        
        }
    },
    methods: {
        btnClick() {
            this.$emit('callback')
        },
        cancelClick() {
            this.$emit('cancel')
        },
        submitClick() {
            this.$emit('submit')
        },
    }
})
export default class HomeModal extends Vue {}
